// Endereço colado traz caractere invisível junto.
//
// DEFEITO REAL, 21/10/2026: enviar para "victorshi@parisi.com" dava "Erro
// interno". Colados no fim do endereço vinham U+202F (espaço estreito) e
// U+2060 (word joiner) — os dois sem desenho nenhum na tela. O Postfix
// recusou, e quem enviou tentou três vezes o mesmo endereço, porque não
// havia nada de errado para ver.
//
// O SERVIDOR TAMBÉM LIMPA, e é ele quem manda (ver api/interno/correio/
// endereco.go). Isto aqui existe por outro motivo: o campo mostra o que foi
// digitado, e o que fica no rascunho e na sugestão da agenda sai daqui. Sem
// limpar na tela, o endereço sujo continuaria visível, comparando diferente
// de si mesmo na lista de contatos já escolhidos.
//
// `trim()` SOZINHO NÃO BASTA: U+202F é espaço para o JavaScript e sai, mas
// U+2060 é categoria Cf — formatação — e fica. Como ele vinha por último, o
// U+202F nem chegava a ser aparado. Era exatamente o par que derrota a
// limpeza ingênua.
const INVISIVEIS = /\p{Cf}/gu;

export function limparEndereco(endereco: string): string {
  return endereco.replace(INVISIVEIS, "").trim();
}

/** Separa a linha digitada em endereços limpos, descartando o que sobrar vazio. */
export function separarEnderecos(texto: string): string[] {
  return texto
    .split(/[,;]/)
    .map(limparEndereco)
    .filter(Boolean);
}
